// extracted by mini-css-extract-plugin
export default {"sortList":"sortList_o0AaT","item":"item_Txu_l","header":"header_aQDp8","action":"action_YgDM4","body":"body_U_YOa"};